import { CodeWindow, Typography } from "@beamcloud/design-system";
import styled from "styled-components";

export const ContentH1 = styled(Typography).attrs({
  tag: "h1",
  variant: "title4Xl",
  color: "gray12",
})`
  && {
    padding: 24px 0px 8px;
  }
`;

export const ContentH2 = styled(Typography).attrs({
  tag: "h2",
  variant: "title3Xl",
  color: "gray100",
})`
  && {
    padding: 20px 0px 8px;
  }
`;

export const ContentH3 = styled(Typography).attrs({
  tag: "h3",
  variant: "title2Xl",
  color: "gray100",
})`
  && {
    padding: 16px 0px 4px;
  }
`;

export const ContentH4 = styled(Typography).attrs({
  tag: "h4",
  variant: "titleXl",
  color: "gray100",
})`
  && {
    padding: 12px 0px 4px;
  }
`;

export const ContentNormal = styled(Typography).attrs({
  tag: "p",
  variant: "textLg",
  color: "gray300",
})``;

export const ContentBlockQuote = styled(Typography).attrs({
  tag: "blockquote",
  variant: "headingXl",
  color: "gray100",
})`
  && {
    padding: 12px 24px;
    margin: 24px 0;
    border-left: 2px solid ${props => props.theme.colors.gray600};
  }
`;

export const ContentUnorderdList = styled(Typography).attrs({
  tag: "ul",
  variant: "textLg",
  color: "gray300",
})`
  && {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0;
    padding-inline-start: 30px;
  }
`;

export const ContentOrderedList = styled(Typography).attrs({
  tag: "ol",
  variant: "textLg",
  color: "gray300",
})`
  && {
    display: flex;
    list-style-type: decimal;
    flex-direction: column;
    gap: 5px;
    margin: 0;
    padding-inline-start: 30px;
  }
`;

export const ContentImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px 0;
  padding: 24px;
  gap: 10px;
  background: ${props => props.theme.colors.gray850};
  border: 1px solid ${props => props.theme.colors.gray7};
  border-radius: 8px;
`;

export const ContentImage = styled.img`
  width: 100%;
`;

export const ContentCode = styled(CodeWindow)`
  && {
    margin: 16px 0;
    width: 100%;
    background-color: ${props => props.theme.colors.gray850};
  }
`;

export const ContentLink = styled.a`
  color: ${props => props.theme.colors.blue400};
`;

export const ContentInlineCode = styled.code`
  padding: 2px 6px;
  border-radius: 6px;
  background-color: ${props => props.theme.colors.gray700};
`;

export const ContentTableWrapper = styled.div`
  margin: 24px 0;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.gray7};
`;

export const ContentTableCaption = styled.div`
  text-align: center;
  margin-bottom: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.gray11};
  padding: 0 20px;
`;

export const ContentTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  background: ${props => props.theme.colors.gray850};
`;

export const ContentTableHeader = styled.th`
  padding: 12px 16px;
  background-color: ${props => props.theme.colors.gray5};
  color: ${props => props.theme.colors.gray12};
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid ${props => props.theme.colors.gray7};
  border-right: 1px solid ${props => props.theme.colors.gray7};

  &:last-child {
    border-right: none;
  }
`;

export const ContentTableCell = styled.td`
  padding: 12px 16px;
  color: ${props => props.theme.colors.gray11};
  border-bottom: 1px solid ${props => props.theme.colors.gray7};
  border-right: 1px solid ${props => props.theme.colors.gray7};

  &:last-child {
    border-right: none;
  }
`;

export const ContentTableRow = styled.tr<{ isEven: boolean }>`
  background-color: ${props => (props.isEven ? props.theme.colors.gray4 : props.theme.colors.gray3)};

  &:last-child {
    ${ContentTableCell} {
      border-bottom: none;
    }
  }
`;
